import { createReducer } from './utils';

import {
  USERS_REQUEST,
  USERS_AVAILABLE,
  USERS_UNAVAILABLE,
  USERS_USERNAME_AVAILABLE,
  USER_PROFILE_REQUEST,
  USER_PROFILE_AVAILABLE,
  USER_PROFILE_UNAVAILABLE,
  USER_COSMETICS_REQUEST,
  USER_COSMETICS_AVAILABLE,
  USER_COSMETICS_UNAVAILABLE,
  USER_LOGOUT,
  USER_ROLES_REQUEST,
  USER_ROLES_AVAILABLE,
  USER_ROLES_UNAVAILABLE,
  USER_SESSION_SET,
  USER_UPDATE,
  USER_UPDATED,
  USER_UPDATE_FAILED,
  USER_DELETE,
  USER_DELETED,
  USER_DELETE_FAILED,
  USER_MY_PROJECTS,
  USER_HIDE_FINISHED,
  USER_SHOW_BOOKMARKED,
  USER_SELECTED_PET_REQUEST,
  USER_SELECTED_PET_AVAILABLE,
  USER_SELECTED_PET_UNAVAILABLE,
  USER_SELECTED_PET_UPDATE,
  USER_SELECTED_PET_UPDATED,
  USER_SELECTED_PET_UPDATE_FAILED,
  SNACK_SET,
} from './constants';

const defaultState = {
  loading_users: false,
  users: false,
  username: '',
  loading_profile: false,
  profile: {},
  profileState: false,
  sesion: false,
  roles: '',
  loading_roles: false,
  sent: false,
  updating_tags: false,
  deleting_tags: false,
  hideFinished: true,
  myProjects: false,
  showBookmarked: false,
  isAdmin: false,
  loading_cosmetics: false,
  userCosmetics: [],
  selectedPetId: null,
  loading_selected_pet: false,
};

export const reducer = createReducer(defaultState, {
  [USER_PROFILE_REQUEST]: handleProfileRequest,
  [USER_PROFILE_AVAILABLE]: handleProfileAvailable,
  [USER_PROFILE_UNAVAILABLE]: handleProfileUnavailable,
  [USER_COSMETICS_REQUEST]: handleCosmeticsRequest,
  [USER_COSMETICS_AVAILABLE]: handleCosmeticsAvailable,
  [USER_COSMETICS_UNAVAILABLE]: handleCosmeticsUnavailable,
  [USERS_REQUEST]: handleUsersRequest,
  [USERS_AVAILABLE]: handleUsersAvailable,
  [USERS_UNAVAILABLE]: handleUsersUnavailable,
  [USER_ROLES_REQUEST]: handleRoleRequest,
  [USER_ROLES_AVAILABLE]: handleRoleAvailable,
  [USER_ROLES_UNAVAILABLE]: handleRoleUnavailable,
  [USER_UPDATE]: handleUserUpdate,
  [USER_UPDATED]: handleUserUpdateSuccess,
  [USER_UPDATE_FAILED]: handleUserUpdateFailure,
  [USER_DELETE]: handleUserDelete,
  [USER_DELETED]: handleUserDeleted,
  [USER_DELETE_FAILED]: handleUserDeleteFailure,
  [USER_MY_PROJECTS]: handleMyProjects,
  [USER_HIDE_FINISHED]: handleHideFinished,
  [USER_SHOW_BOOKMARKED]: handleShowBookmarked,
  [USER_SELECTED_PET_REQUEST]: handleSelectedPetRequest,
  [USER_SELECTED_PET_AVAILABLE]: handleSelectedPetAvailable,
  [USER_SELECTED_PET_UNAVAILABLE]: handleSelectedPetUnavailable,
  [USER_SELECTED_PET_UPDATE]: handleSelectedPetUpdate,
  [USER_SELECTED_PET_UPDATED]: handleSelectedPetUpdated,
  [USER_SELECTED_PET_UPDATE_FAILED]: handleSelectedPetUpdateFailed,
});

function handleProfileRequest(state, _) {
  return {
    ...state,
    loading_profile: true,
  };
}

function handleProfileAvailable(state, { payload: { profile, isAdmin } }) {
  return {
    ...state,
    profile: profile,
    loading_profile: false,
    profileState: true,
    isAdmin: isAdmin,
  };
}

function handleProfileUnavailable(state, _) {
  return defaultState;
}

function handleCosmeticsRequest(state, _) {
  return {
    ...state,
    loading_cosmetics: true,
  };
}

function handleCosmeticsAvailable(state, { payload: { cosmetics } }) {
  return {
    ...state,
    userCosmetics: cosmetics,
    loading_cosmetics: false,
  };
}

function handleCosmeticsUnavailable(state, _) {
  return {
    ...state,
    loading_cosmetics: false,
    userCosmetics: [],
  };
}

function handleUsersRequest(state, _) {
  return {
    ...state,
    loading_users: true,
  };
}

function handleUsersUnavailable(state, _) {
  return defaultState;
}

function handleUsersAvailable(state, { payload: { users } }) {
  return {
    ...state,
    loading_users: false,
    users: true,
    userList: users,
  };
}

function handleRoleRequest(state, _) {
  return {
    ...state,
    loading_roles: true,
  };
}

function handleRoleAvailable(state, { payload: { roles } }) {
  return {
    ...state,
    roles: roles,
    loading_roles: false,
  };
}

function handleRoleUnavailable(state, _) {
  return defaultState;
}

function handleUserUpdate(state, _) {
  return {
    ...state,
    updating_tags: true,
  };
}

function handleUserUpdateSuccess(state, _) {
  return {
    ...state,
    sent: true,
    updating_tags: false,
  };
}

function handleUserUpdateFailure(state, _) {
  return defaultState;
}

function handleUserDelete(state, _) {
  return {
    ...state,
    deleting_tags: true,
  };
}

function handleUserDeleted(state, _) {
  return {
    ...state,
    deleting_tags: false,
  };
}

function handleUserDeleteFailure(state, _) {
  return defaultState;
}

function handleMyProjects(state, { payload: { myProjects } }) {
  return {
    ...state,
    myProjects: myProjects,
  };
}

function handleHideFinished(state, { payload: { hideFinished } }) {
  return {
    ...state,
    hideFinished: hideFinished,
  };
}
function handleShowBookmarked(state, { payload: { showBookmarked } }) {
  return {
    ...state,
    showBookmarked: showBookmarked,
  };
}

function handleSelectedPetRequest(state, _) {
  return {
    ...state,
    loading_selected_pet: true,
  };
}

function handleSelectedPetAvailable(state, { payload: { selectedPetId } }) {
  return {
    ...state,
    selectedPetId: selectedPetId,
    loading_selected_pet: false,
  };
}

function handleSelectedPetUnavailable(state, _) {
  return {
    ...state,
    selectedPetId: null,
    loading_selected_pet: false,
  };
}

function handleSelectedPetUpdate(state, _) {
  return {
    ...state,
    loading_selected_pet: true,
  };
}

function handleSelectedPetUpdated(state, { payload: { selectedPetId } }) {
  return {
    ...state,
    selectedPetId: selectedPetId,
    loading_selected_pet: false,
  };
}

function handleSelectedPetUpdateFailed(state, _) {
  return {
    ...state,
    loading_selected_pet: false,
  };
}

export function getUsers() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: USERS_REQUEST });
    try {
      const users = await dataSource.getUsers();
      dispatch({
        type: USERS_AVAILABLE,
        payload: { users },
      });
    } catch (error) {
      dispatch({
        type: USERS_UNAVAILABLE,
        payload: { error },
      });
    }
  };
}

export function setShowMyProjects(myProjects) {
  return async dispatch => {
    dispatch({
      type: USER_MY_PROJECTS,
      payload: { myProjects },
    });
  };
}

export function setHideFinishedProjects(hideFinished) {
  return async dispatch => {
    dispatch({
      type: USER_HIDE_FINISHED,
      payload: { hideFinished },
    });
  };
}

export function setShowBookmarked(showBookmarked) {
  return async dispatch => {
    dispatch({
      type: USER_SHOW_BOOKMARKED,
      payload: { showBookmarked },
    });
  };
}

export function getUserRoles() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: USER_ROLES_REQUEST });
    try {
      const roles = await dataSource.getUserRoles();
      dispatch({
        type: USER_ROLES_AVAILABLE,
        payload: { roles },
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: USER_ROLES_UNAVAILABLE,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'There was an error',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function updateUser(user) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    try {
      dispatch({ type: USER_UPDATE });
      await dataSource.updateUser(user);
      dispatch({ type: USER_UPDATED });
      const snack = {
        open: true,
        message: 'User updated',
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    } catch (error) {
      dispatch({
        type: USER_UPDATE_FAILED,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'There was an error',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function deleteUser(userId) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    try {
      dispatch({ type: USER_DELETE });
      await dataSource.deleteUser(userId);
      dispatch({ type: USER_DELETED });
      const snack = {
        open: true,
        message: 'User deleted',
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    } catch (error) {
      dispatch({
        type: USER_DELETE_FAILED,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'There was an error',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getUserCosmetics() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: USER_COSMETICS_REQUEST });
    try {
      const cosmetics = await dataSource.getUserCosmetics();
      dispatch({
        type: USER_COSMETICS_AVAILABLE,
        payload: { cosmetics },
      });
    } catch (error) {
      dispatch({
        type: USER_COSMETICS_UNAVAILABLE,
        payload: { error },
      });
    }
  };
}

export function getUserSelectedPet() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: USER_SELECTED_PET_REQUEST });
    try {
      const response = await dataSource.getUserSelectedPet();
      dispatch({
        type: USER_SELECTED_PET_AVAILABLE,
        payload: { selectedPetId: response.selected_pet_id },
      });
    } catch (error) {
      dispatch({
        type: USER_SELECTED_PET_UNAVAILABLE,
        payload: { error },
      });
    }
  };
}

export function patchUserSelectedPet(selectedCosmeticId) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    // Optimistic update
    const previousPetId = getState().users.selectedPetId;
    dispatch({
      type: USER_SELECTED_PET_UPDATED,
      payload: { selectedPetId: selectedCosmeticId },
    });

    try {
      const cosmetics = await dataSource.patchUserSelectedPet(selectedCosmeticId);
      
      // Update cosmetics with the new list returned by the API
      dispatch({
        type: USER_COSMETICS_AVAILABLE,
        payload: { cosmetics },
      });

      const snack = {
        open: true,
        message: 'Selected pet updated',
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    } catch (error) {
      // Rollback optimistic update
      dispatch({
        type: USER_SELECTED_PET_UPDATED,
        payload: { selectedPetId: previousPetId },
      });
      
      dispatch({
        type: USER_SELECTED_PET_UPDATE_FAILED,
        payload: { error },
      });
      const snack = {
        open: true,
        message: 'Error updating pet',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}
